$('.blogfilter_form select').each(function() {
    $(this).select2({
        placeholder: "Select",
        containerCssClass: 'select2-css',
        minimumResultsForSearch: Infinity,
    });
});
